import {
  ref,
  uploadBytes,
  getDownloadURL,
  deleteObject,
} from "firebase/storage";
import { storage } from "./firebase";

// Each contrato keeps a single document at a stable path (per extension) so
// replacing it overwrites the old file. We store the canonical filename the
// user chose (for display), the extension and the download URL on the
// contrato document. Soportamos PDF y Word (.doc / .docx).
const MIME_EXT = {
  "application/pdf": "pdf",
  "application/msword": "doc",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "docx",
};

const extFromFile = (file) => {
  if (file.type && MIME_EXT[file.type]) return MIME_EXT[file.type];
  const name = (file.name || "").toLowerCase();
  if (name.endsWith(".pdf")) return "pdf";
  if (name.endsWith(".docx")) return "docx";
  if (name.endsWith(".doc")) return "doc";
  return null;
};

const pathFor = (contratoId, ext) => `contratos/${contratoId}/contrato.${ext}`;

export const uploadContratoArchivo = async (file, contratoId, previous = null) => {
  if (!file) throw new Error("Archivo requerido");
  if (!contratoId) throw new Error("Contrato no guardado");
  const ext = extFromFile(file);
  if (!ext) throw new Error("Solo se aceptan PDF o Word (.doc, .docx)");

  const path = pathFor(contratoId, ext);
  const storageRef = ref(storage, path);
  const contentType =
    file.type ||
    (ext === "pdf" ? "application/pdf" : "application/octet-stream");
  await uploadBytes(storageRef, file, { contentType });
  const url = await getDownloadURL(storageRef);

  // Si el reemplazo cambia de extension (ej. PDF -> docx), borrar el archivo anterior.
  if (previous?.path && previous.path !== path) {
    try {
      await deleteObject(ref(storage, previous.path));
    } catch (e) {
      if (e.code !== "storage/object-not-found") console.error(e);
    }
  }

  return {
    url,
    path,
    ext,
    name: file.name || `contrato.${ext}`,
    size: file.size || 0,
    uploadedAt: new Date().toISOString(),
  };
};

export const deleteContratoArchivo = async (meta) => {
  // Acepta el meta guardado (con .path) o, por compatibilidad, un path string.
  const path = typeof meta === "string" ? meta : meta?.path;
  if (!path) return;
  try {
    await deleteObject(ref(storage, path));
  } catch (e) {
    if (e.code === "storage/object-not-found") return;
    throw e;
  }
};

// ¿El documento es un Word? (mira la extension guardada o el nombre)
export const esWord = (meta) =>
  meta?.ext === "doc" ||
  meta?.ext === "docx" ||
  /\.docx?($|\?)/i.test(meta?.name || "");
